<!-- 货主费用登记类目 costRegisterManger  -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :btnFlag="false" :buttonFlag="false">
                <template slot="button">
                    <div>
                        <el-button type="primary" size="mini" @click="actionSet(0)">添加</el-button>
                        <el-button type="primary" size="mini" @click="actionSet(1)">修改</el-button>
                        <el-button type="primary" size="mini" @click="actionSet(2)">删除</el-button>
                        <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
                            刷新
                        </el-button>
                    </div>
                </template>
            </v-button>
            <div class="page_content_top_line">
                <vSearch :flagList="['cateType']" @searchData="searchData" :getRequestData=getRequestData v-if="formList.costRegisterManger" :searchList=formList.costRegisterManger>
                    <template slot="searchInput">
                        <el-select v-model="getRequestData.cateType">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in options" :key="item.value" :label="item.key" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="cateName" label="项目名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" prop="cateType" label="项目类别" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag size="mini">{{scope.row.cateType == 0 ? '扣除' : '增加'}}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="actionData.cate" :activeName="actionData.cate==0? '新增':'修改'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}">
                        <template slot="tabs" slot-scope="scope">
                            <div style="margin:10px 0;" v-if="scope.index==0">
                                <el-form size="mini" label-width="100px" :model="sendDataInfo" label-position="right" inline>
                                    <el-row>
                                        <el-form-item label="项目名称" placeholder="请输入项目名称" prop="cateName" :rules="[{required: true, trigger: ['blur', 'change']}]">
                                            <label slot="label" :style="$common.labelStyle('项目名称')" v-html="'项目名称'"></label>
                                            <el-input v-model.trim="sendDataInfo.cateName" class="form_codition"></el-input>
                                        </el-form-item>
                                        <el-form-item label="项目类别">
                                            <label slot="label" :style="$common.labelStyle('项目类别')" v-html="'项目类别'"></label>
                                            <el-select v-model="sendDataInfo.cateType" placeholder="请选择项目类别" class="form_codition">
                                                <el-option v-for="item in options" :key="item.value" :label="item.key" :value="item.value" :before-close="cancelReview"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="cancelReview">取消</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="actionData.cate==0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="actionData.cate==1">保存</el-button>
                </div>
            </div>

        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                cateName: "", //	项目名称		false	
                cateType: "", //	项目类别，0扣除，1增加		false	
                creater: 0, //		false	
                page: 1,
                rows: 30,
                start: "",
                end: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            tabForm: [
                {
                    jciName: "新增"
                }
            ],
            selectedDataIndex: 0,
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: "",
            smId: "",
            isShowTooltip: false,
            showStatus: false,
            actionData: {},
            parentSearchData: {},
            sField: "",
            cateList: [],
            sendDataInfo: {
                cateName: "", //	项目名称		false	
                cateType: 0, //	项目类别，0扣除，1增加
            },
            options: [
                { key: "增加", value: 1 },
                { key: "扣除", value: 0 },
            ],
            formList: {
                costRegisterManger:
                    [
                        {
                            entityField: "cateName",
                            fieldType: "string",
                            formatterContent: null,
                            isRequired: 0,
                            isShow: 1,
                            searchId: "",
                            extractId: null,
                            setField: '',
                            showField: "项目名称",
                        },
                        {
                            entityField: "cateType",
                            fieldType: "formatter",
                            formatterContent: null,
                            isRequired: 0,
                            isShow: 1,
                            searchId: "",
                            extractId: null,
                            setField: '',
                            showField: "项目类别",
                        },
                    ]
            }
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.smId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        cancelReview() {
            this.showStatus = false;
            this.init()
        },
        async sendDataAction() {
            if (this.sendDataInfo.cateName == "") {
                return this.$message({
                    message: "请填写项目名称",
                    type: "error",
                });
            }
            var responseData;
            if (this.actionData.cate == 0) {
                responseData = await this.$http.ownerexPensecateAdd(this.sendDataInfo);
            } else {
                responseData = await this.$http.ownerexPensecateUpdate(this.sendDataInfo);
            }

            if (responseData.status == 200) {
                this.$message({
                    message: responseData.message,
                    type: "success",
                });
                this.showStatus = false
                this.init();
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({
                    //向窗口发送MessageEvent消息
                    cmd: "returnFormJson",
                    params: {
                        isPenetrate
                    }, //参数
                },
                    "*"
                );
            }
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.psomBuycus = dataInfo.smId;
                        this.getRequestData.smName = dataInfo.smName;
                    }
                    break;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                // this.getButtonList();
                // this.queryCate()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionType) {
            switch (actionType) {
                case 0:
                    this.showStatus = true;
                    this.tabForm[0].jciName = "新增"
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.psomId,
                        printSouce: "",
                        printJurId: "",
                    };
                    this.tabForm[0].jciName = "修改"
                    this.sendDataInfo.cateName = dataInfo.cateName
                    this.sendDataInfo.cateType = dataInfo.cateType
                    this.sendDataInfo.ercId = dataInfo.ercId
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.ownerexPensecateOwnList(
                this.getRequestData
            );
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData));
                this.returnData.list = resData.result.list;
                this.returnData.pages = resData.result.pages;
                this.returnData.total = resData.result.total;
                this.returnData.pageNum = resData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.ercId],
                    }
                    let responseData = await this.$http.ownerexPensecateDelete(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
async queryCate() {
            var responseData = await this.$http.queryCate();
            if (responseData.status == 200) {
                this.cateList = responseData.result
            } else {
                this.$message({
                    message: '获取登记项目异常',
                    type: "error",
                });
            }
        },
        init() {
            for (const key in this.sendDataInfo) {
                if (key == 'cateType') {
                    this.sendDataInfo[key] = 0
                } else {
                    this.sendDataInfo[key] = ""
                }
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>